var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsteroid1Temp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Asteroid_1",
    "data-name": "Asteroid 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 302.89 329.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".asteroid-cls1{fill:#aeb9bb;}.asteroid-cls2{fill:#bac5c7;}.asteroid-cls3{fill:#d0d9d6;}.asteroid-cls4{fill:#94a09e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asteroid 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls1",
    d: "M105.28,258.38c0-16,31.13-30.06,35.68-44.6,4.69-15-20.63-18.61-11.89-31.22,15.76-22.72,40.9-70.16,66.32-81.72,19.39-8.81,26.2-14.9,48.89-14.9,33.42,0,58.75,39.87,84,58,10.42,7.48,25.47,6.34,33.72,16.13a153.27,153.27,0,0,1,30.64,58.16c3.59,13-10.85,29-10.85,43.15,0,16.54,13.74,30.24,8.91,45.17a153.16,153.16,0,0,1-20.22,40.63c-14.86,21.27-23.2,39.43-46.66,51C303.36,408.16,268.6,413,244.28,413c-9.3,0-17.18-8.83-26-10.41-13.31-2.38-10.88,1.54-22.77-4-16.88-7.9-6-9.56-18.85-22.74-16.76-17.16-72-47.45-79.3-70.94C92.84,290.42,105.28,274.31,105.28,258.38Z",
    transform: "translate(-90.31 -83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls2",
    d: "M275.66,191.52c11.9,25.27-33.61,26.72-33.61,26.72s-1.49,13.38,0,16.35,5.94-1.48,3,11.89-14.87,8.92-19.33,13.38-7.43,17.84-13.37,17.84,23.21,41.66,17.26,58-53.51,40.14-53.51,40.14l-41.68-38.66-8.29-53.54L154.34,193S216.2,57.73,281.61,94.89,274.15,184.61,275.66,191.52Z",
    transform: "translate(-90.31 -83)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls3",
    d: "M282.31,94.93s-28.72,31.57-40.26,52c-7,12.39,1.68,35.27,0,38.65-4.46,8.92-4.6,23.9-14,44.63-20.81,46.08-26.18,16.31-33.61,29.69s9.83,53.55-5,68.42-53-8.13-50,12.27c0,0-43.09-13.79-49-52.44-1.27-8.25,9.38-20.27,11.89-28.25,2.71-8.58-2.49-13.07,2.31-20.37a164.27,164.27,0,0,1,25.94-30.17s-11.32-10.44-8.92-23.78S132,170.67,132,170.67s22.3-43.11,28.25-44.6,19.32-32.7,37.16-37.16S266.08,75.68,282.31,94.93Z",
    transform: "translate(-90.31 -83)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls2",
    d: "M303,317.84c-11.37-18.6,4.46-32.71,28.25-50.54,16.29-12.22,23.47-10.92,34.84,7.67s4.06,47.49-13.31,58.12c-9.23,5.64-16.74-.21-26-4.85C318.62,324.15,308.33,326.55,303,317.84Z",
    transform: "translate(-90.31 -83)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls4",
    d: "M307.86,311.33c-9.63-15.75,5.41-20.55,20.11-29.55s23.52-18.78,33.15-3S364.56,319,349.85,328c-4.67,2.85-13.7-11.07-18.61-11.61C320.68,315.2,314.43,322.07,307.86,311.33Z",
    transform: "translate(-90.31 -83)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls2",
    d: "M107.44,295.5s10.67-3.57,16.21-10.89,9.29-13.42,9.22-19.36-.63-6.77.2-13.32-3.81-15.42-6.17-15-6.83,6.79-6.12,13-3,12.32-5,17.22-6.58,11.61-9.08,15.68S97.8,294.78,107.44,295.5Z",
    transform: "translate(-90.31 -83)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls4",
    d: "M130.91,257.39a21.4,21.4,0,0,1-1.75,13.76c-3.51,7.27-6.22,13.81-10.8,15.3s-11.94.12-7.63-7.88S120,270,121.22,263.48s2.35-20.28,7.42-18.16S130.91,257.39,130.91,257.39Z",
    transform: "translate(-90.31 -83)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls2",
    d: "M361,233.11s10.41-13.38,7.43-20.82-5.94-4.46-7.43-11.89-3.43-20.76-11.89-11.89c-9.77,10.23-16.51,29-11.9,35.68C340.66,229.24,350.56,239.05,361,233.11Z",
    transform: "translate(-90.31 -83)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls4",
    d: "M362.46,221.21s-1.49-13.38-8.92-19.32-14.87,19.32-14.87,19.32S353.54,240.54,362.46,221.21Z",
    transform: "translate(-90.31 -83)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls2",
    d: "M190.42,203.37s14.46-12.06,14.46-17.83,3.85-21.43,0-25.27-24.08-5-26-1.13-9.62,23.08-5.77,26.93,11.54,17.3,11.54,17.3Z",
    transform: "translate(-90.31 -83)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls4",
    d: "M190,200.4s7.43-8.92,7.43-13.38,3-14.86,0-17.84-14.87-5.94-16.35-3-7.43,17.84-4.46,20.81,8.92,13.38,8.92,13.38Z",
    transform: "translate(-90.31 -83)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls2",
    d: "M289.58,156.09s0-18.81-11.28-15.05-18.8,13.17-18.8,18.81,1.88,13.16,9.4,15S291.46,167.37,289.58,156.09Z",
    transform: "translate(-90.31 -83)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls4",
    d: "M285.16,157.29s0-14.86-8.92-11.89-14.87,10.41-14.87,14.87,1.49,10.4,7.43,11.89S286.64,166.21,285.16,157.29Z",
    transform: "translate(-90.31 -83)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls2",
    d: "M274.81,283.33s12.09-1.13,8.84-9.84-9.86-14.09-13.49-13.75-8.33,2.28-9,8.35S267.69,285.5,274.81,283.33Z",
    transform: "translate(-90.31 -83)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls4",
    d: "M273.77,280.58s9.56-.89,7.11-6.45-7.59-8.94-10.46-8.67-6.6,1.58-7.2,5.5S268.12,282.07,273.77,280.58Z",
    transform: "translate(-90.31 -83)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls2",
    d: "M284.68,399.92s23.69-20.6,35.69-25.87S350,352.91,350,352.91s-3-6.86-10.83-1.39S308,369.24,299.25,377.18,279,396.28,284.68,399.92Z",
    transform: "translate(-90.31 -83)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "asteroid-cls4",
    d: "M291.54,393.67s18.8-16.36,28.33-20.53,23.49-16.79,23.49-16.79-2.39-5.44-8.6-1.1-24.68,14.06-31.65,20.37S287,390.78,291.54,393.67Z",
    transform: "translate(-90.31 -83)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsteroid1Temp);
export default __webpack_public_path__ + "static/media/asteroid1-temp.0251e857e88290ede0c0228884bba44e.svg";
export { ForwardRef as ReactComponent };